
import React, { Component } from "react";
import BsyTableList from "../BsyTableList";
import BsyGroupList from "../BsyGroupList";
import BsySwitchBtn from "../BsySwitchBtn";
import BsyIconBtn from "../BsyIconBtn";
import BsySearchInput from "../BsySearchInput";
import BsyAlertListDetail from '../BsyAlertListDetail'
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyAlertInviteUser from "../BsyAlertInviteUser";
import { BsyUtils } from "../../utils/Utils";
import BsyDialog from '../BsyDialog';
import BsyApprovePane from '../BsyApprovePane';
import BsyAlertHandover from "../BsyAlertHandover";
import './index.css';






export default class BsyOutsider extends Component {

    constructor(props) {
        super(props)
        this.state = {
            verifyBtn: true,
            outsiderCont: {
                users: [],
                count: 0,
                not_joined: 0,
                has_qr_modify: false,
            },
            outsiders: [{
                "_id": "default",
                "name": React.language('default.group'),
                "sort": "0",
                "type": "1"  //1是默认分组
            }], //外联系人分组分组列表
            hasCount: true,
            limit: 20,
            skip: 0,
            filter: "",
            miniAppSet: false, //小程序设置
            isCheck: false,
            selectGroup: 'default',
            selectGroupName: React.language('default.group'),
            openurl: '',
            openurl_switch: false,
            audit_switch: false,
            nocheck: false, //批量导入外部联系不 不验证
            checkList: [],
            checkListDetail:[],
            filterText: React.language('all'),
            inviteStatus: 0,
        }

        this.emailCodeLogin = false;

    }

    componentDidMount() {
        this.getOutsiderList();

    }

    getOutsiderList = () => {
        React.axios('/corp/outsider/list', {
        }).then(res => {
            this.emailCodeLogin = res.data.emailCodeLogin;
            this.setState({
                outsiders: [...res.data.list],
                selectGroup: res.data.list[0]._id,
                selectGroupName: res.data.list[0].name,
                isCheck: res.data.list[0].isCheck,
                openurl_switch: res.data.list[0].openurl_switch,
                audit_switch: res.data.list[0].audit_switch,
                openurl: res.data.list[0].openurl,
                miniAppSet: res.data.list[0].mini,
                nocheck: res.data.nocheck,
                outsiderMemberInvite: res.data.outsiderMemberInvite,
                outsiderMemberRemove: res.data.outsiderMemberRemove,
                outsiderRemove: res.data.outsiderRemove,
            }, () => {

                this.RefreshList();
                this.get_approve_list();
            })
        }).catch(res => {

        })
    }

    closeCheckMenu = () =>{
        this.setState({checkList: [], checkListDetail: [], checked: false})
    }

    outsiderNodeClick = (node) => {
        // this.RefreshList()

        this.setState({
            selectGroup: node ? node._id : '',
            selectGroupName: node ? node.name : React.language('outsider.custom.all'),
            isCheck: node ? node.isCheck : false,
            miniAppSet: !node ? false : node.mini,
            openurl: !node ? '' : node.openurl,
            openurl_switch: !node ? false : node.openurl_switch,
            audit_switch: !node ? false : node.audit_switch,
            skip: 0,
            filter: ""
        }, () => {
            this.RefreshList();
            this.get_approve_list();
        })

    }

    eventCustMent = (type, node, event) => {

        const { outsiders } = this.state;
        switch (type) {
            case "del": {
                BsyAlert({
                    title: React.language("delete.confirm", {
                        name: node.name
                    }),
                    msg: React.language("outsider.group.delete.tip"),
                    type: "warning",
                    text4Ok: React.language("delete"),
                    OkType: "red",
                    text4Cancel: React.language("cancel"),
                    ok: () => {

                        React.axios("/corp/outsider/remove", {
                            group_id: node._id
                        }).then(res => {

                            BsyUtils.showAjaxTip(res.data, () => {
                                const newOutsiders = outsiders.filter((item, index) => {
                                    return item._id !== node._id;

                                })
                                this.setState({ outsiders: newOutsiders })
                            })

                        }).catch(res => {

                        })
                    }
                })
                break;
            }
            case 'rename': {
                const _this = this;
                var f = new window.FX.ConfirmDialog({
                    title: React.language("outsider.group.edit"),
                    width: 340,
                    height: 170,
                    text4Ok: React.language("ok"),
                    contentWidget: {
                        rowSize: [30],
                        colSize: [300],
                        padding: 20,
                        items: [[{
                            type: "text",
                            value: node.name,
                            widgetName: "groupName",
                            allowBlank: !1
                        }]]
                    },
                    onOk: function () {
                        var g = this.getWidgetByName("groupName");
                        var value = g.getValue();
                        if (!value) {
                            tipAlert({
                                type: "warning",
                                msg: React.language('outsider.name.empty')
                            })
                            return;
                        }
                        if (node.name === value) {
                            f.close()
                            return;
                        }

                        React.axios("/corp/outsider/update",
                            { "name": value, "group_id": node._id })
                            .then(res => {

                                BsyUtils.showAjaxTip(res.data, () => {

                                    const newOutsiders = outsiders.map((item, index) => {
                                        if (item._id === node._id) {
                                            item.name = value;
                                        }
                                        return item;
                                    })
                                    _this.setState({ outsiders: newOutsiders })
                                    f.close()
                                })

                            }).catch(res => {
                                // console.log(res)
                            })
                    }
                });
                f.show()
                break;
            }
            case 'ID': {
                window.FX.Msg.nAlter({
                    renderEl: window.$(event.target),
                    title: React.language("department.id"),
                    name: node._id,
                    mode: "show"
                })
                break;
            }
            default: {

            }
        }
    }

    outsiderGroupMoreOperate = (e, node) => {
        // this.RefreshList()
        // this.setState({ selectGroup: node._id })
        const {outsiderRemove} = this.state;

        if (node.type == 1) {
            this.eventCustMent('rename', node);
        } else {
            let menu = [{
                text: React.language('group.id'),
                colorType: "",
                click: () => {
                    this.eventCustMent('ID', node, e);
                }
            },{
                text: React.language('rename'),
                colorType: "",
                click: () => {
                    this.eventCustMent('rename', node);
                }
            }]
            if(outsiderRemove){
                menu = [{
                    text: React.language('group.id'),
                    colorType: "",
                    click: () => {
                        this.eventCustMent('ID', node, e);
                    }
                },{
                    text: React.language('rename'),
                    colorType: "",
                    click: () => {
                        this.eventCustMent('rename', node);
                    }
                }, {
                    text: React.language('delete'),
                    colorType: "red",
                    click: () => {
                        this.eventCustMent('del', node);
                    }
                }]
            }
            BsyAlertMenu({
                item: menu,
                // renderEl: e.currentTarget,
                width: 140,
                target: e.currentTarget,

            })

        }

    }

    skipChange = (val) => {
        this.setState({ skip: val }, () => {
            this.RefreshList()
        })
    }

    listLimitChange = (val) => {
        this.setState({ limit: val }, () => {
            this.RefreshList()
        })
    }

    listFilterChange = (val) => {
        this.setState({ filter: val }, () => {
            this.RefreshList()
        })
    }

    memberUpdate = (data) => {

        React.axios("/corp/outsider/member/update", data).then(res => {
            BsyUtils.showAjaxTip(res.data, () => {
                this.RefreshList();
                tipAlert({
                    type: "success",
                    msg: React.language("update.success")
                })
            })

        }).catch(res => {

        })
    }

    _createChangeDepartmentBubble = (b) => {
        if (!b || b.length <= 0)
            return void tipAlert({
                type: "warning",
                msg: React.language("move.tip")
            });
        let that = this;
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 576,
            width: 710,
            contentWidget: {
                rowSize: [440],
                colSize: [680],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    hasDock: false,
                    memberEnable: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    roleEnable: !1,
                    dynamicEnable: !1,
                    dynamicType: "set"
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                if (d1.departs.length == 0) {
                    return
                }

                React.axios("/corp/outsider/member/transfer", {
                    user_id: b,
                    departmentId: d1.departs
                }).then(res => {
                    BsyUtils.showAjaxTip(res.data, () => {
                        that.RefreshList();
                        d.close()
                    })

                }).catch(res => {

                })
                return !1;
            }
        });
        d.show()
    }


    memberRowClick = (event, item) => {
        const {outsiderMemberRemove} = this.state;
        if (event.target.classList[0] === "icon-flow-other" || event.target.classList[0] === "menuTd") {
            let menu = [{
                text: React.language('edit'),
                colorType: "",
                click: () => {
                    const node = {
                        ...item,
                        ...{
                            memberStatus: this.state.selectGroup ? this.state.selectGroup : item.group_id,
                            memberType: 'outsider',
                            groupname: item.groupname ? item.groupname : this.state.selectGroupName,
                            onSave: (data) => {
                                const newDate = {
                                    ...data,
                                    ...{
                                        user_id: item._id,
                                        group_id: this.state.selectGroup === 'deleted' ? "" : data.group_id,
                                        name: data.nickname,
                                        uniqueid: data.userUniqueId
                                    }
                                }
                                this.memberUpdate(newDate)
                            }
                        }
                    }
                    BsyAlertListDetail({
                        ...node, onReList: () => {
                            this.RefreshList()
                        }
                    })
                }
            }];

            if (item.category == 2) {
                menu = [{
                    text: React.language('edit'),
                    colorType: "",
                    click: () => {
                        const node = {
                            ...item,
                            ...{
                                memberStatus: this.state.selectGroup ? this.state.selectGroup : item.group_id,
                                memberType: 'outsider',
                                groupname: item.groupname ? item.groupname : this.state.selectGroupName,
                                onSave: (data) => {
                                    const newDate = {
                                        ...data,
                                        ...{
                                            user_id: item._id,
                                            group_id: this.state.selectGroup === 'deleted' ? "" : data.group_id,
                                            name: data.nickname,
                                            uniqueid: data.userUniqueId
                                        }
                                    }
                                    this.memberUpdate(newDate)
                                }
                            }
                        }
                        BsyAlertListDetail({
                            ...node, onReList: () => {
                                this.RefreshList()
                            }
                        })
                    }
                }, {
                    text: React.language('handover.work'),
                    colorType: "",
                    click: () => {
                        // this.removeAlert()
                        // BsySliderHandover({
                        //     userInfo:item,
                        //     title:React.language('handover.work')
                        // })
                        BsyAlertHandover({
                            userInfo: item,
                            title: React.language('handover.work'),
                            styleCss: {
                                width: "966px",
                                height: "582px",
                                maxHeight: "calc(100% - 100px)"
                            },
                            onClose: () => {
                                this.RefreshList()
                            }
                        })
                    }
                },{
                    text: React.language(item.frozen === 0 ? 'deactivate' : 'enable'),
                    colorType: "",
                    click: () => {
                        const { _id } = item;
                        BsyAlert({
                            title: React.language(item.frozen === 0 ? "deactivate.alert.tip" : "enable.alert.tip"),
                            msg: React.language((item.frozen === 0 ? "deactivate.alert.tip1" : "enable.alert.tip1"),{length1: 1, length2: 1}),
                            type: "query",
                            text4Ok: React.language(item.frozen === 0 ? 'deactivate' : 'enable'),
                            OkType: item.frozen === 0 ? "red" : "blue",
                            text4Cancel: React.language("cancel"),
                            ok: () => {
                                //     this.removeAlert()
                                React.axios(item.frozen === 1 ? '/corp/member/batch_recover' : '/corp/member/batch_freeze', {
                                    member_id_list: [_id]
                                }).then(res => {
                                    tipAlert({
                                        type: 'success',
                                        msg: React.language(item.frozen === 0 ? 'deactivate.success.tip' : 'enable.success.tip', {length: res.data.data.success_num, users: item.nickname})
                                    })
                                    this.RefreshList()
                                }).catch(res => {

                                })
                            }
                        })
                    }
                }
                    , {
                    text: React.language('outsider.member.to.dept'),
                    colorType: "",
                    click: () => {

                        BsyAlert({
                            title: React.language("outsider.to.user.tip"),
                            msg: '',
                            type: "warning",
                            text4Ok: React.language("ok"),
                            OkType: "red",
                            text4Cancel: React.language("cancel"),
                            ok: () => {
                                this._createChangeDepartmentBubble(item._id);
                            }
                        })


                    }
                }];

                if (!BsyUtils.isCommon()) {
                    menu = [{
                        text: React.language('edit'),
                        colorType: "",
                        click: () => {
                            const node = {
                                ...item,
                                ...{
                                    memberStatus: this.state.selectGroup ? this.state.selectGroup : item.group_id,
                                    memberType: 'outsider',
                                    groupname: item.groupname ? item.groupname : this.state.selectGroupName,
                                    onSave: (data) => {
                                        const newDate = {
                                            ...data,
                                            ...{
                                                user_id: item._id,
                                                group_id: this.state.selectGroup === 'deleted' ? "" : data.group_id,
                                                name: data.nickname,
                                                uniqueid: data.userUniqueId
                                            }
                                        }
                                        this.memberUpdate(newDate)
                                    }
                                }
                            }
                            BsyAlertListDetail({
                                ...node, onReList: () => {
                                    this.RefreshList()
                                }
                            })
                        }
                    },{
                        text: React.language(item.frozen === 0 ? 'deactivate' : 'enable'),
                        colorType: "",
                        click: () => {
                            const { _id } = item;
                            BsyAlert({
                                title: React.language(item.frozen === 0 ? "deactivate.alert.tip" : "enable.alert.tip"),
                                msg: React.language((item.frozen === 0 ? "deactivate.alert.tip1" : "enable.alert.tip1"),{length1: 1, length2: 1}),
                                type: "query",
                                text4Ok: React.language(item.frozen === 0 ? 'deactivate' : 'enable'),
                                OkType: item.frozen === 0 ? "red" : "blue",
                                text4Cancel: React.language("cancel"),
                                ok: () => {
                                    //     this.removeAlert()
                                    React.axios(item.frozen === 1 ? '/corp/member/batch_recover' : '/corp/member/batch_freeze', {
                                        member_id_list: [_id]
                                    }).then(res => {
                                        tipAlert({
                                            type: 'success',
                                            msg: React.language(item.frozen === 0 ? 'deactivate.success.tip' : 'enable.success.tip', {length: res.data.data.success_num, users: item.nickname})
                                        })
                                        this.RefreshList()
                                    }).catch(res => {

                                    })
                                }
                            })
                        }
                    }];
                    menu.push({
                        text: React.language('handover.work'),
                        colorType: "",
                        click: () => {
                            // this.removeAlert()
                            // BsySliderHandover({
                            //     userInfo:item,
                            //     title:React.language('handover.work')
                            // })
                            BsyAlertHandover({
                                userInfo: item,
                                title: React.language('handover.work'),
                                styleCss: {
                                    width: "966px",
                                    height: "582px",
                                    maxHeight: "calc(100% - 100px)"
                                },
                                onClose: () => {
                                    this.RefreshList()
                                }
                            })
                        }
                    })
                }

                if (BsyUtils.isOutdiser() && BsyUtils.isSubAdmin()) {
                    menu = [{
                        text: React.language('edit'),
                        colorType: "",
                        click: () => {
                            const node = {
                                ...item,
                                ...{
                                    memberStatus: this.state.selectGroup ? this.state.selectGroup : item.group_id,
                                    memberType: 'outsider',
                                    groupname: item.groupname ? item.groupname : this.state.selectGroupName,
                                    onSave: (data) => {
                                        const newDate = {
                                            ...data,
                                            ...{
                                                user_id: item._id,
                                                group_id: this.state.selectGroup === 'deleted' ? "" : data.group_id,
                                                name: data.nickname,
                                                uniqueid: data.userUniqueId
                                            }
                                        }
                                        this.memberUpdate(newDate)
                                    }
                                }
                            }
                            BsyAlertListDetail({
                                ...node, onReList: () => {
                                    this.RefreshList()
                                }
                            })
                        }
                    }, {
                        text: React.language('handover.work'),
                        colorType: "",
                        click: () => {
                            // this.removeAlert()
                            // BsySliderHandover({
                            //     userInfo:item,
                            //     title:React.language('handover.work')
                            // })
                            BsyAlertHandover({
                                userInfo: item,
                                title: React.language('handover.work'),
                                styleCss: {
                                    width: "966px",
                                    height: "582px",
                                    maxHeight: "calc(100% - 100px)"
                                },
                                onClose: () => {
                                    this.RefreshList()
                                }
                            })
                        }
                    }];
                }
            }

            if (this.state.selectGroup === 'deleted') {
                menu = [{
                    text: React.language('recover'),
                    click: () => {
                        const { _id, groupname } = item;

                        if (!groupname) {
                            this._createChangOutsiderBubble(_id);
                        } else {
                            BsyAlert({
                                title: React.language("outsider.member.recover.tip"),
                                // msg: React.language("dismission.alert.tip1"),
                                type: "query",
                                text4Ok: React.language('recover'),
                                OkType: 'blue',
                                text4Cancel: React.language("cancel"),
                                ok: () => {
                                    let url = '/corp/outsider/member/recover'
                                    React.axios(url, {
                                        user_id: [_id]
                                    }).then(res => {
                                        BsyUtils.showAjaxTip(res.data, () => {
                                            this.RefreshList();
                                        })
                                    }).catch(res => {

                                    })
                                }
                            })
                        }


                    }
                }, {
                    text: React.language('handover.work'),
                    colorType: "",
                    click: () => {
                        // this.removeAlert()
                        // BsySliderHandover({
                        //     userInfo:item,
                        //     title:React.language('handover.work')
                        // })
                        BsyAlertHandover({
                            userInfo: item,
                            title: React.language('handover.work'),
                            styleCss: {
                                width: "966px",
                                height: "582px",
                                maxHeight: "calc(100% - 100px)"
                            },
                            onClose: () => {
                                this.RefreshList()
                            }
                        })
                    }
                }]
            }

            if(outsiderMemberRemove){
                menu.push({
                    text: React.language('delete'),
                    colorType: "red",
                    click: () => {
                        const { _id } = item;
                        BsyAlert({
                            title: React.language("del.tip1"),
                            msg: '',
                            type: "warning",
                            text4Ok: React.language("delete"),
                            OkType: "red",
                            text4Cancel: React.language("cancel"),
                            ok: () => {
                                React.axios("/corp/outsider/member/remove", {
                                    user_id: [_id], // 成员ID
                                }).then(res => {
                                    tipAlert({
                                        type: "success",
                                        msg: React.language("member.delete.success")
                                    })
                                    this.RefreshList()
                                }).catch(res => {
    
                                })
                            }
                        })
                    }
                })
            }

            BsyAlertMenu({
                item: menu,
                // renderEl: event.currentTarget,
                width: 140,
                target: event.target
            })
        } else if (event.target.classList[1] === "again") {
            // const mobile = item.phone
            // if (!mobile) {
            //     tipAlert({
            //         type: "warning",
            //         msg: React.language("Invited.tip1")
            //     })
            //     return;
            // }
            this.againAllInvite(item.phone)

        } else {

            const node = {
                ...item,
                ...{
                    memberStatus: this.state.selectGroup ? this.state.selectGroup : item.group_id,
                    groupname: item.groupname ? item.groupname : this.state.selectGroupName,
                    memberType: 'outsider',
                    onSave: (data) => {
                        const newDate = {
                            ...data,
                            ...{
                                user_id: item._id,
                                group_id: this.state.selectGroup === 'deleted' ? "" : data.group_id,
                                name: data.nickname,
                                uniqueid: data.userUniqueId,
                            }
                        }
                        this.memberUpdate(newDate)
                    }
                }
            }
            BsyAlertListDetail({
                ...node, onReList: () => {
                    this.RefreshList()
                }
            })
        }


    }

    _createChangOutsiderBubble = (_id) => {

        let that = this;
        const d = new window.FX.ConfirmDialog({
            title: React.language("outsider.member.recover.groupempty.tip"),
            height: 576,
            width: 710,
            contentWidget: {
                rowSize: [440],
                colSize: [680],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    radioEnable: !0,
                    checkEnable: !1,
                    memberEnable: !1,
                    departmentEnable: !1,
                    outsiderMemberEnable: !1,
                    // outsiderGroupEnable:!1,
                    roleEnable: !1,
                    dynamicEnable: !1,
                    dynamicType: "set",
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                if (d1.outsiderGroup.length === 0) {
                    return
                }

                let url = '/corp/outsider/member/recover'
                React.axios(url, {
                    user_id: [_id],
                    group_id: d1.outsiderGroup[0],
                }).then(res => {
                    BsyUtils.showAjaxTip(res.data, () => {
                        that.RefreshList();
                        d.close()
                    })
                }).catch(res => {

                })

                return !1;
            }
        });
        d.show()
    }

    outsiderGroupNodeMove = (attr) => {

        // console.log(result)
        const customGroup = [...this.state.outsiders];
        customGroup.splice(0, 1)
        const groupList = this.reorder(
            customGroup,
            attr.source.index,
            attr.destination.index
        );
        const outsiders = [...[this.state.outsiders[0]], ...groupList];
        // this.props.outsiders = groupList;

        let data = {
            "group_id": attr.draggableId,  //被移动的成员
            "prev": attr.destination.index === 0 ? "" : outsiders[attr.destination.index]._id
        }
        this.setState({
            outsiders: outsiders
        }, () => {
            React.axios('/corp/outsider/sort', data).then(res => {

            }).catch(res => {

            })
        });
    }

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        // const first = result.splice(0, 1);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    getTableValue = (rel) => {
        this.tableValue = rel
    }

    outsiderNodeAdd = () => {
        const _this = this;
        var f = new window.FX.ConfirmDialog({
            title: React.language("outsider.add"),
            width: 340,
            height: 170,
            text4Ok: React.language("add"),
            contentWidget: {
                rowSize: [30],
                colSize: [300],
                padding: 20,
                items: [[{
                    type: "text",
                    widgetName: "groupName",
                    waterMark: React.language('outsider.name.required'),
                    allowBlank: !1
                }]]
            },
            onOk: function () {
                var g = this.getWidgetByName("groupName");
                var value = g.getValue();
                if (!value) {
                    tipAlert({
                        type: "warning",
                        msg: React.language('outsider.name.empty')
                    })
                    return;
                }
                React.axios("/corp/outsider/create",
                    { "name": value })
                    .then(res => {
                        BsyUtils.showAjaxTip(res.data, () => {
                            const newOutsiders = [..._this.state.outsiders, ...[res.data.data]]
                            _this.setState({ outsiders: newOutsiders })
                            f.close()
                        })
                    }).catch(res => {
                        console.log(res)
                    })
            }
        });
        f.show()
    }

    onSearch = () => {
        this.setState({
            skip: 0,
            filter: this.searchValue.getValue()
        }, () => {
            this.RefreshList();
        })
    }

    RefreshList = () => {
        const { selectGroup, limit, skip, filter, inviteStatus } = this.state

        let url = '/corp/outsider/member/list';
        if (selectGroup === 'deleted') {
            url = '/corp/outsider/member/delete_list';
        }
        // selectGroup 为空的时候 查询所有数据 不传分组id给后端
        React.axios(url, {
            group_id: selectGroup === 'deleted' ? undefined : !selectGroup ? undefined : selectGroup,
            hasCount: true,
            key: filter,
            searchType: 'all',
            limit: limit,
            skip: skip * limit,
            status: inviteStatus,
        }).then(res => {

            const outsider = {
                ...{
                    users: res.data.list,
                    count: res.data.count,
                    not_joined: res.data.not_joined,
                    not_validate: res.data.not_validate,
                }
            }

            this.setState({
                checkList: [], checkListDetail: [], checked: false,
                outsiderCont: outsider
            })

        }).catch(res => {

        })
    }

    getSearchValue = (ref) => {
        this.searchValue = ref
    }

    handleUserOrder = (data) => {
        React.axios('/corp/outsider/member/sort', data).then(res => {

        }).catch(res => {

        })
    }
    handleBatchOpMember = (type) => {
        const { checkListDetail } = this.state;
        let members = [];
        let flag = false;

        if (!checkListDetail || checkListDetail.length <= 0) {
            tipAlert({
                type: 'warning',
                msg: React.language('outsider.member.' + type + '.empty')
            })
            return
        }
        checkListDetail.forEach((val, obj) => {
            members.push(val._id)
        })

        if (flag) {
            tipAlert({
                type: 'warning',
                msg: React.language('outsider.member.' + type + '.empty')
            })
            return
        }
        BsyAlert({
            title: React.language("outsider.member." + type + ".tip"),
            // msg: React.language("dismission.alert.tip1"),
            type: "query",
            text4Ok: React.language(type),
            OkType: type === 'remove' ? "red" : 'blue',
            text4Cancel: React.language("cancel"),
            ok: () => {
                let url = '/corp/outsider/member/' + type
                React.axios(url, {
                    user_id: members
                }).then(res => {
                    BsyUtils.showAjaxTip(res.data, () => {
                        this.RefreshList();
                    })
                }).catch(res => {

                })
            }
        })
    }
    handleMiniAppConfig = () => {

        const currentNode = this.state.outsiders.filter((item, index) => {
            return item._id === this.state.selectGroup;
        })

        const node = {
            ...currentNode[0],
            ...{
                type: 'miniAppSet',
                group_id: currentNode[0]._id,
                group_type: currentNode[0].type,
                onUpdata: (data) => {
                    //更新当前这条 分组消息
                    const { outsiders } = this.state;
                    this.setState({
                        outsiders: outsiders.map((item, index) => {
                            if (item._id === currentNode[0]._id) {
                                item.wxmini_join = data.wxmini_join
                            }
                            return item;
                        })
                    })
                    // const newDate = {
                    //     ...data,
                    //     ...{
                    //         user_id: item._id,
                    //         group_id: this.state.selectGroup == 'deleted' ? "" : this.state.selectGroup,
                    //         name:data.nickname,
                    //         uniqueid:data.userUniqueId
                    //     }
                    // }
                    // this.memberUpdate(newDate)
                }
            }
        }
        BsyAlertListDetail({
            ...node, onReList: () => {
                this.RefreshList()
            }
        })
    }

    againAllValidate = () =>{
        BsyAlert({
            title: React.language("verify.all.tip"),
            msg: "",
            type: "query",
            text4Ok: React.language("ok"),
            text4Cancel: React.language("cancel"),
            OkType: "blue",
            ok: function () {
                React.axios('/corp/outsider/validate', {
                    // mobile: !mobile ? "all" : mobile
                    mode: "all",
                    memberIds: []
                }).then(res => {
                    tipAlert({
                        type: "success",
                        msg: React.language("Invited.tip3")
                    })
                }).catch(res => {
                    tipAlert({
                        type: "error",
                        msg: React.language("member.invite.error.tip")
                    })
        
        
                    // window.FX.Vip.showUpgradeTip(res.data.responseJSON)
                })
            }
        })
        
    }

    verifyEmailMobile = (type, id, event) =>{
        event.stopPropagation();
        const {verifyBtn} = this.state;
        if(verifyBtn){
            this.setState({verifyBtn:false},function(){
                React.axios('/corp/outsider/validate',{
                    mode: type,
                    memberIds: [id]
                }).then(res => {
                    this.setState({verifyBtn:true})
                    tipAlert({
                        type: res.data.success == 1 ? "success" : "error",
                        msg: res.data.info
                    })
                    
                }).catch(res => {
                    this.setState({verifyBtn:true})
                })
            })
            
        }
    }

    againAllInvite = (mobile) => {
        const { selectGroup } = this.state;
        BsyAlert({
            title: mobile ? React.language("Invited.tip2", { mobile: mobile }) : React.language("Invited.all.tip"),
            msg: "",
            type: "query",
            text4Ok: React.language("ok"),
            text4Cancel: React.language("cancel"),
            OkType: "blue",
            ok: function () {
                React.axios('/corp/outsider/reinvite', {
                    group_id: selectGroup,
                    mobile: !mobile ? "all" : mobile
                }).then(res => {

                    BsyUtils.showAjaxTip(res.data, function () {
                        tipAlert({
                            type: "success",
                            msg: React.language("Invited.tip3")
                        })
                    })
                }).catch(res => {
                    tipAlert({
                        type: "error",
                        msg: React.language("member.invite.error.tip")
                    })

                    // window.FX.Vip.showUpgradeTip(res.data.responseJSON)
                })
            }
        })
    }
    handleAddMember = () => {
        const { selectGroup } = this.state;
        BsyAlertInviteUser({
            title: React.language('outsider.member.add'),
            type: 'outsider',
            group_id: selectGroup,
            groupname: this.state.selectGroupName,
            openurl: this.state.openurl,
            openurl_switch: this.state.openurl_switch,
            approve_switch: this.state.isCheck,
            nocheck: this.state.nocheck,
            emailCodeLogin: this.emailCodeLogin,
            onRefresh: () => {
                this.RefreshList();
            },
            onRefreshAll: () => {
                this.getOutsiderList();
            },
            onRefreshOusiders: (val) => {
                const { outsiders } = this.state;
                const newOutsiders = outsiders.map((item, index) => {
                    if (selectGroup === item._id) {
                        return {
                            ...item,
                            ...val
                        }
                    }
                    return item
                })
                this.setState({
                    outsiders: newOutsiders,
                    ...val
                })
            },
            styleCss: {
                width: 760,
                height: 570
            }
        })
    }

    switchChange = (val) => {
        this.setState({
            outsiderCont: {
                has_qr_modify: val,
                users: [...this.state.outsiderCont.users],
                count: this.state.outsiderCont.count,
                not_joined: this.state.outsiderCont.not_joined,
            }
        })
    }

    miniAppSwitch = () => {
        if (this.state.selectGroup === 'deleted') {
            return '';
        }

        if (!this.state.selectGroup) {
            //全部联系人
            return <div className='refresh' onClick={this.groupRefresh}>
                <i className="icon-refresh"></i>
                <span>{React.language('refresh')}</span>
            </div>;
        }

        if (!this.state.miniAppSet) {
            return '';
        }

        return (
            <div className="switchCont">
                <div className="qywechatConfig" onClick={(e) => { this.handleMiniAppConfig() }}>
                    {React.language('outsider.miniapp.seting')}
                </div>
            </div>
        )

    }

    onCheck = (e) =>{
        this.setState({checkList: e.checkList, checkListDetail: e.checkListDetail, checked: e.checked})
    }

    get_approve_list = () => {
        const { selectGroup, limit } = this.state
        if (selectGroup == "deleted") {
            this.setState({
                approves: false,
            })
        } else {
            // selectGroup 为空的时候 查询所有数据 不传分组id给后端
            React.axios('/corp/apply_check_list', {
                group_id: selectGroup,
                mode: "outsider",
                limit: limit,
                status: 0, //查询未审核的人
                skip: 0
            }).then(res => {

                this.setState({
                    approves: res.data.count > 0 ? true : false,
                })

            }).catch(res => {

            })
        }

    }

    approve_list = (val) => {

        const { selectGroupName, selectGroup } = this.state
        BsyDialog({
            title: React.language('outsiderGroup') + ' - ' + selectGroupName,
            height: 600,
            width: 966,
            noFooter: true,
            onContentCreate: () => {
                return <BsyApprovePane
                    group_id={selectGroup} mode={'outsider'} status={3} />

            }
        })
    }

    groupRefresh = () => {
        this.setState({
            skip: 0
        }, function () {
            this.RefreshList();
        })

    }

    renderInviteUserBtn = () => {
        // BsyUtils.isSubAdmin()
        const {outsiderMemberInvite} = this.state;
        //子管理员
        if (outsiderMemberInvite && !BsyUtils.isObjectEmpty(this.state.selectGroup)) {
            return <BsyIconBtn
                text={React.language('outsider.member.add')}
                iconName="icon-addUser"
                type="blue"
                click={(e) => { this.handleAddMember() }}
                mode={window.mode}
            />
        }

        return ''

    }

    onBsyTurnPageMid = () => {
        const { outsiderCont } = this.state;
        return <>
            {(outsiderCont.not_joined > 0 ||  outsiderCont.not_validate > 0) && <div className="tip-list">
                
                {
                    outsiderCont.not_joined > 0 && <div className="joined-tip tip-item" onClick={e => { this.againAllInvite() }}  >
                        {/* <i className={'icon-bsy-laba'} /> */}
                        <div dangerouslySetInnerHTML={{ __html: React.language('addressbook.joined.tip', { num: outsiderCont.not_joined }) }} />
                    </div>
                }
                {
                    outsiderCont.not_validate > 0 && <div className="validate-tip tip-item" onClick={e => { this.againAllValidate() }}  >
                        {/* <i className={'icon-bsy-laba'} /> */}
                        <div dangerouslySetInnerHTML={{ __html: React.language('member.not.verify.tip1', { num: outsiderCont.not_validate }) }} />
                    </div>
                }
            </div>}
        </>
    }

    filterPane = (event, type) => {
        let bts = [
          { icon: '', text: React.language('all'), click: () =>{
            this.setState({filterText: React.language('all'), inviteStatus: 0, isFilter: true},()=>{
                this.RefreshList()
            })
          }},
          { icon: '', text: React.language('member.inviting'), click: () =>{
            this.setState({filterText: React.language('member.inviting'), inviteStatus: 1, isFilter: true},()=>{
                this.RefreshList()
            })
          }},
            { icon: '', text: React.language('activated'), click: () =>{
                    this.setState({filterText: React.language('activated'), inviteStatus: 2, isFilter: true},()=>{
                        this.RefreshList()
                    })
                }},
            { icon: '', text: React.language('deactivated'), click: () =>{
                    this.setState({filterText: React.language('deactivated'), inviteStatus: 3, isFilter: true},()=>{
                        this.RefreshList()
                    })
                }},
        ]
        const t = event.currentTarget;
        t.classList.add('open');
        BsyAlertMenu({
            item: bts,
            width: 120,
            target: t,
            customCls: ' data-manage-batch-menu ',
            onClose: ()=>{
                t.classList.remove('open');
                return !0
            }
        })
    }

    enableClick = () => {

        const { checkListDetail } = this.state;
        const _this = this;
        let members = [];
        let users = [];
        let flag = false;
        checkListDetail.forEach((val, obj) => {
            if (val.category === 2) {
                if(val.frozen !== 0){
                    members.push(val._id)
                    users.push(val.nickname)
                }
            } else {
                flag = true
            }
        })

        if (flag) {
            tipAlert({
                type: 'warning',
                msg: React.language('enable.error.tip')
            })
            return
        }

        if (!members || members.length <= 0) {
            tipAlert({
                type: 'warning',
                msg: React.language('enable.error.tip2')
            })
            return
        }

        BsyAlert({
            type: "query",
            title: React.language("enable.alert.tip"),
            msg: React.language("enable.alert.tip1",{length1: checkListDetail.length, length2: members.length}),
            text4Ok: React.language("enable"),
            text4Cancel: React.language("cancel"),
            OkType: "blue",
            ok: function () {
                React.axios('/corp/member/batch_recover', {
                    member_id_list: members
                }).then(res => {
                    tipAlert({
                        type: 'success',
                        msg: React.language('enable.success.tip', {length: res.data.data.success_num, users: users.join("、")})
                    })
                    _this.RefreshList()
                }).catch(res => {

                })
            }
        });
    }

    deactivateClick = () => {

        const { checkListDetail } = this.state;
        const _this = this;
        let members = [];
        let users = [];
        let flag = false;

        checkListDetail.forEach((val, obj) => {
            if (val.category === 2) {
                if(val.frozen === 0){
                    members.push(val._id)
                    users.push(val.nickname)
                }
            } else {
                flag = true
            }
        })

        if (flag) {
            tipAlert({
                type: 'warning',
                msg: React.language('deactivate.error.tip')
            })
            return
        }

        if (!members || members.length <= 0) {
            tipAlert({
                type: 'warning',
                msg: React.language('deactivate.error.tip2')
            })
            return
        }

        BsyAlert({
            type: "query",
            title: React.language("deactivate.alert.tip"),
            msg: React.language("deactivate.alert.tip1",{length1: checkListDetail.length, length2: members.length}),
            text4Ok: React.language("deactivate"),
            text4Cancel: React.language("cancel"),
            OkType: "red",
            ok: function () {
                React.axios('/corp/member/batch_freeze', {
                    member_id_list: members
                }).then(res => {
                    tipAlert({
                        type: 'success',
                        msg: React.language('deactivate.success.tip', {length: res.data.data.success_num, users: users.join("、")})
                    })
                    _this.RefreshList()
                }).catch(res => {

                })
            }
        });
    }

    render() {
        const { filterText, outsiderCont, limit, skip, outsiders, selectGroup, selectGroupName, approves, outsiderMemberRemove, verifyBtn, checkList, checkListDetail, checked } = this.state;
        const { currentCorpId } = this.props;
        let list = [{
            width: 177,
            key: "nickname",
            value: React.language("name"),
            title: true,//给元素添加title属性
        }, {
            width: 177,
            key: "uniqueid",
            value: React.language("enterprise.user.id"),
            tooltip: !0 ? React.language("enterprise.tip") : React.language("enterprise.tip1")
        }, {
            width: 147,
            key: "phone",
            value: React.language("phone"),
            onCellCreate: (items, value) => {
                return <>
                    <span title={value.phone} className="text">{value.phone }</span>
                    {value.phone && value.mobilestatus == 0 && <span className={"verify " + (verifyBtn ? '' : 'not')} onClick={e =>{this.verifyEmailMobile('mobile', value._id, e)}}>
                        {
                            React.language('verify')
                        }
                    </span>}
                </>
                
            },
        }, {
            width: 197,
            key: "email",
            value: React.language("email"),
            onCellCreate: (items, value) => {
                return <>
                    <span title={value.email} className="text">{value.email }</span>
                    {value.email && value.emailstatus == 0 && <span className={"verify " + (verifyBtn ? '' : 'not')} onClick={e =>{this.verifyEmailMobile('email', value._id, e)}}>
                        {
                            React.language('verify')
                        }
                    </span>}
                </>
            },
            tooltip: React.language("member.email.verify.tip")
        }, {
            width: 116,
            key: "remark",
            value: React.language("contact.note.title"),

        }, {
            width: 80,
            key: "again",
            value: "",

        }]
        if (!selectGroup) {
            list = [{
                width: 177,
                key: "nickname",
                value: React.language("name"),
                title: true,//给元素添加title属性
                
            }, {
                width: 176,
                key: "uniqueid",
                value: React.language("enterprise.user.id"),
                tooltip: !0 ? React.language("enterprise.tip") : React.language("enterprise.tip1")
            }, {
                width: 146,
                key: "phone",
                value: React.language("phone")
            }, {
                width: 196,
                key: "email",
                value: React.language("email"),
                onCellCreate: (items, value) => {
                    return <>
                        <span title={value.email} className="text">{value.email }</span>
                        {value.email && value.emailstatus == 0 && <span className={"verify " + (verifyBtn ? '' : 'not')} onClick={e =>{this.verifyEmailMobile('email', value._id, e)}}>
                            {
                                React.language('verify')
                            }
                        </span>}
                    </>
                },
                tooltip: React.language("member.email.verify.tip")
            }, {
                width: 119,
                key: "groupname",
                value: React.language("group"),

            }, {
                width: 80,
                key: "again",
                value: "",

            }]
        }
        if (selectGroup === 'deleted') {
            list = [{
                width: 250,
                key: "nickname",
                value: React.language("name"),
                title: true,//给元素添加title属性

            }, {
                width: 196,
                key: "uniqueid",
                value: React.language("enterprise.user.id"),
                tooltip: !0 ? React.language("enterprise.tip") : React.language("enterprise.tip1")
            }, {
                width: 200,
                key: "groupname",
                value: React.language("group"),
            }, {
                width: 176,
                key: "leave_time",
                value: React.language("field.deleteTime"),
            },

            {
                width: 80,
                key: "again",
                value: "",

            }]
        }

        let defList = [outsiders[0]];
        let goupList = [];
        outsiders.map((res, key)=>{
            if(key === 0){
                return
            }
            res.icon = "icon-outsdier-custom-group"
            goupList.push(res)
        })
        return (

            <div className={"outsiderCont " + window.mode}>
                <div className="outsiderMenu">

                    <div className={'outsider-all'}
                        onClick={e => { this.outsiderNodeClick(null) }}
                    ><i className={'icon-outsdier-all-member'} /><span title={React.language('outsider.view.custom.all')} >{React.language('outsider.view.custom.all')}</span> </div>
                    <div className="group-title">
                        <span>{React.language('default.group')}</span>
                    </div>
                    <div className="defGroupList">
                        {
                            defList.map(res => {
                                return <div className={"def-group-item " + (selectGroup === res._id ? 'select':'')} onClick={() => this.outsiderNodeClick(res)}>
                                    <i className="title-icon icon-outsider-member"></i>
                                    <span>{res.name}</span>
                                    <i className="op icon-flow-other" onClick={(e)=> this.outsiderGroupMoreOperate(e, res)}></i>
                                </div>
                            })
                        }
                    </div>
                    <div className="group-title">
                        <span>{React.language('outsider.custom.group')}</span>
                        <i className="icon-add" onClick={this.outsiderNodeAdd}></i>
                    </div>
                    
                    <BsyGroupList
                        groups={goupList}
                        selectGroup={selectGroup}
                        nodeClick={(node) => this.outsiderNodeClick(node)}
                        nodeAdd={() => this.outsiderNodeAdd()}
                        hasMenu={true}
                        hasCustom={false}
                        outsiderMemberRemove={false}
                        nodeSort={(attr) => this.outsiderGroupNodeMove(attr)}
                        nodeMoreOperate={(e, node) => this.outsiderGroupMoreOperate(e, node)}
                        sortable={!BsyUtils.isSubAdmin()}
                        hasAdd={!BsyUtils.isSubAdmin()}
                        hasDeletedList={!BsyUtils.isSubAdmin()}
                    />
                    <div className={"other-set " + (selectGroup === "deleted" ? 'select':'')} onClick={()=>{this.outsiderNodeClick({
                            "_id": "deleted",
                            "name": React.language('deleted.outdiser'),
                            "sort": "0",
                            "type": "1"  //1是默认分组
                        })}}><i className="icon-bsy-reportmenu-9"></i><span>{React.language('deleted.outdiser')}</span></div> 
                </div>
                <div className="outsiderContent">
                    <div className="outsiderTitle">
                        <div className="leftoutsiderCont">
                            <div className="title">
                                {selectGroupName}
                            </div>
                            {/* <div className="refresh" onClick={this.groupRefresh} >
                                 <i className={ 'icon-async' } />
                            </div> */}
                        </div>
                        {
                            !currentCorpId && this.miniAppSwitch()
                        }
                    </div>
                    
                    {checkList.length <= 0 ? <div className="outsiderFunBtn">
                        <div className="btnCont">
                            {
                                (selectGroup !== 'deleted' && selectGroup) ? this.renderInviteUserBtn() : ''
                            }

                            {

                                BsyUtils.isSubAdmin() ? '' : approves ? <BsyIconBtn
                                    text={React.language('member.invite.link.Audit.list')}
                                    type="white"
                                    iconName="icon-bsy-audit-list"
                                    hoverType="borderBlue"
                                    click={this.approve_list}
                                    mode={window.mode}
                                /> : ''
                            }


                        </div>
                        <div className="searchCont">
                            <div className="filter-btn" onClick={this.filterPane}>
                                <span>{filterText}</span>
                                <i className="icon-bsy-xia"></i>
                            </div>
                            <BsySearchInput
                                placeholder={React.language('member.search1')}
                                styleInput={{
                                    'width': '200px',
                                    height: '32px',
                                    lineHeight: '30px'
                                }}
                                getValue={this.getSearchValue}
                                onSearch={this.onSearch}
                                type={window.mode}
                                // iconName="icon-bsy-reportmenu-0"
                            />
                        </div>
                    </div> : <div className="check-menu">
                            <div className="close-btn" onClick={this.closeCheckMenu}>
                                <i className="icon-close-large"></i>
                            </div>
                            <div className="total-cont">
                                <span className="checked-num-wrapper">
                                    <span className="checked-title">{React.language('msg.target.set.selected')}</span>
                                    <span className="checked-num">{checkList.length}</span>
                                    /{outsiderCont.users.length}
                                </span>
                            </div>
                            {
                                (selectGroup !== 'deleted' && outsiderMemberRemove) && <div className="set-btn" onClick={(e) => { this.handleBatchOpMember('remove') }}>
                                    <i className="icon-signout"></i>
                                    <span>{React.language("bulk.removal")}</span>
                                </div>
                            }
                            {
                                <div className="set-btn" onClick={this.enableClick}>
                                    <i className="icon-bsy-enable"></i>
                                    <span>{React.language("enable")}</span>
                                </div>
                            }
                            {
                                <div className="set-btn" onClick={this.deactivateClick}>
                                    <i className="icon-bsy-deactivate"></i>
                                    <span>{React.language("deactivate")}</span>
                                </div>
                            }

                        </div>}
                    {
                        this.onBsyTurnPageMid()
                    }
                    {outsiderCont.users &&
                        <BsyTableList
                            getValue={this.getTableValue}
                            limit={limit}
                            skip={skip}
                            skipChange={this.skipChange}
                            listLimitChange={this.listLimitChange}
                            listFilterChange={this.listFilterChange}
                            styleType={window.mode}
                            userCont={outsiderCont}
                            count={outsiderCont.count}
                            hasTurnPage={!!outsiderCont.count}
                            list={list}
                            checkList={checkList}
                            checkListDetail={checkListDetail}
                            checked={checked}
                            multiple={selectGroup !== 'deleted'}
                            onRowOrder={e => { this.handleUserOrder(e) }}
                            onReinvite={e => { this.againAllInvite(e) }}
                            onRowClick={(e, node) => { this.memberRowClick(e, node) }}
                            onCheck={(e)=>{
                                this.onCheck(e)
                            }}
                        />}
                </div>
            </div>

        );
    }
}